import { TrackingEvent } from 'client/tracking/event';
import { EditorialMap } from 'client/tracking/maps/editorial';
import { TrackingConstant } from 'client/tracking/constant';
import { generateTrackingIds } from 'site-modules/shared/utils/make-model-zip';

const PAGE_NAME = 'car_reviews_index';
export const MMZ_TRACKING_IDS = generateTrackingIds(PAGE_NAME);

const map = {
  [MMZ_TRACKING_IDS.makeSelectTrackingId]: TrackingEvent.actionStart(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.MAKE_SELECT
  ),

  [MMZ_TRACKING_IDS.modelSelectTrackingId]: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.MODEL_SELECT
  ),

  [MMZ_TRACKING_IDS.yearSelectTrackingId]: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.YEAR_SELECT
  ),

  [MMZ_TRACKING_IDS.submitTrackingId]: TrackingEvent.actionEnd(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.SUBMIT_MMY
  ),
};

export const TrackingMap = {
  ...EditorialMap,
  ...map,
};
